/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import { AS_LOG_OPERATIONS, AS_LOG_STATES } from './exploreConstants';

export const EntityTypePropTypes = PropTypes.shape({
  name: PropTypes.string,
  entities: PropTypes.number,
  dimensionNames: PropTypes.arrayOf(PropTypes.string),
  metricNames: PropTypes.arrayOf(PropTypes.string),
  metricTimestampColumn: PropTypes.string,
});

export const EntityTypesPropTypes = PropTypes.arrayOf(EntityTypePropTypes);

/**
 * the entity type meta data, but none of these fields can be required because on initial fetch none of them exist
 */
export const EntityTypeMetaPropTypes = PropTypes.shape({
  entityTypeId: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  dataItemDto: PropTypes.arrayOf(PropTypes.object),
  dimensionTableName: PropTypes.string,
  metricTableName: PropTypes.string,
  metricTimestampColumn: PropTypes.string,
  schemaName: PropTypes.string,
  status: PropTypes.string,
});

export const EntityTypeDetailsPropTypes = PropTypes.shape({
  name: PropTypes.string,
  entities: PropTypes.number,
});

export const EntityTypeLogsPropTypes = PropTypes.shape({
  operation: PropTypes.oneOf(Object.values(AS_LOG_OPERATIONS)),
  module: PropTypes.string,
  function: PropTypes.string,
  status: PropTypes.oneOf(Object.values(AS_LOG_STATES)),
  message: PropTypes.string,
  errorType: PropTypes.string,
  errorMessage: PropTypes.string,
  errorStacktrace: PropTypes.string,
  logfilePath: PropTypes.string,
  createdTimestamp: PropTypes.string,
  updatedTimestamp: PropTypes.string,
});

export const EntityTypesLogsPropTypes = PropTypes.objectOf(EntityTypeLogsPropTypes);

export const EntityTypesDetailsPropTypes = PropTypes.arrayOf(EntityTypeDetailsPropTypes);
